import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from '../messages';
import { SupplierImport } from './supplier-import';
import { useSuppliersGridContext } from '../suppliers-grid-context';
import { Button } from 'ui-components/components/button';
import style from '../../../../components/grid-header/reusable-grid-button.module.less';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

export const ImportButton = () => {
  const { refreshSuppliers } = useSuppliersGridContext();

  const onImportFinish = useCallback(() => {
    refreshSuppliers();
  }, [refreshSuppliers]);

  return (
    <SupplierImport
      onImportFinish={onImportFinish}
      renderOpener={(open) => {
        return (
          <Button className={style['reusable-button']} onClick={open} theme={THEME_CONSTANTS.tertiary}>
            <FormattedMessage {...messages.importButton} />
          </Button>
        );
      }}
    />
  );
};
